<!-- @format -->

@if (icon ? true : false) {
	<homefield-icon
		height="14px"
		[class]="icon"
		[name]="icon"></homefield-icon>
}
<span
	class="link"
	[ngClass]="{ styled: styled }">
	<ng-content></ng-content>
</span>
